const styles = theme => ({
  container: {
    width: "100%"
  },
  addInput: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-end",
    marginBottom: "20px"
  },
  formControl: {
    margin: theme.spacing.unit
  },
  button: {
    margin: theme.spacing.unit
  },
  backButton: {
    textAlign: "right",
    marginTop: theme.spacing.unit
  }
});
export default styles;
